export const STORAGE_KEY_SESSION_ID = 'AP_SESSION_ID'
export const HEADER_SESSION_ID = 'x-session-id'
export const PKCE_METHOD_PLAIN = 'plain'
